module.exports = __webpack_public_path__ + "static/media/delivered.3261e8be.svg";